import { Injectable } from '@angular/core';
import { CONFIG } from '../shared/config';
import { HttpGeneralService, GeneralSearchParms } from '../shared';
import { DocManagementTrans } from '../docu-manage-new/image-upload-new';
import { createAuthorizationHeader } from '../shared/utility';

const MailsBoxUrl = CONFIG.baseUrls.MailsBox;
let DocManagmentUrl = CONFIG.baseUrls.DocManagment;

export interface MailsBox extends GeneralSearchParms {
  serial: number
  senderSecLoginId: number
  senderEmpId: number
  reciverSecLoginId: number
  reciverGroupId: number
  reciverEmpId: number
  selectAll: number
  reciverGroupIdArray: string
  reciverSecLoginIdArray: string
  subject: string
  message: string
  messageStatus: number
  archived: number
  rowStatus: number
  attachmentUrl: string
  readDate: Date,
  senderNameAr: string,
  regDate: Date,
  reciverNameAr: string;

  //////////// attachment
  publishDocPath?: string;
  docManagementSerial?: number;
  docPath?: string;
  filePath?: string;

  attachments?: any[];
}
@Injectable({
  providedIn: 'root'
})

export class MailsBoxService {
  constructor(private httpGeneralService: HttpGeneralService) { }
  // sentEmail(file: any) {
  //   return this.httpGeneralService.post(file, ``);
  // }

  postMailBox(mailBox: MailsBox) {
    return this.httpGeneralService.add<MailsBox>(mailBox, MailsBoxUrl);
  }
  getMailsBox(MailsBox: MailsBox) {
    return this.httpGeneralService.post(MailsBox, `${MailsBoxUrl}/getMailsBoxData`);
  }

  getSenderMessage(MailsBox: MailsBox) {
    return this.httpGeneralService.post(MailsBox, `${MailsBoxUrl}/GetSendMessage`);
  }

  addMailsBox(MailsBox: MailsBox[]) {
    return this.httpGeneralService.add<MailsBox[]>(MailsBox, MailsBoxUrl);
  }

  updateMailsBox(MailsBox: MailsBox) {
    return this.httpGeneralService.update<MailsBox>(MailsBox.serial, MailsBox, MailsBoxUrl);
  }

  deleteMailsBox(MailsBox: MailsBox) {
    return this.httpGeneralService.delete<number>(MailsBox.serial, MailsBoxUrl);
  }

  SaveNewFile(fileData: DocManagementTrans) {
    return this.httpGeneralService.add(fileData, `${DocManagmentUrl}/SaveNewFile`);
  }

  FileToUploadPost(file: DocManagementTrans) {
    return this.httpGeneralService.add(file, `${DocManagmentUrl}/newSaveForFiles`).toPromise();
  }

  GetImage(DocManagementTrans: DocManagementTrans) {
    let headers = createAuthorizationHeader();
    DocManagmentUrl = this.httpGeneralService.modifyUrl(DocManagmentUrl);
    return `${this.httpGeneralService.apiUrlNew + DocManagmentUrl}/GetImage?type=${DocManagementTrans.docManagementSerial}&id=${DocManagementTrans.tableRowId}&random=${Math.random()}`
  }

  getImagebyName(DocManagementTrans: DocManagementTrans) {
    DocManagmentUrl = this.httpGeneralService.modifyUrl(DocManagmentUrl);
    return `${this.httpGeneralService.apiUrlNew + DocManagmentUrl}/GetImagebyName?type=${DocManagementTrans.docManagementSerial}&id=${DocManagementTrans.tableRowId}&ImageName=${DocManagementTrans.docPath}&DocManagementTransSerial=${DocManagementTrans.serial}`
  }
}


